<template>
  <div class="container">
    <div class="row" id="serachcontainer">
      <div class="col-12">
        <input class="search" type="text"
        :value="search"
        @input="e => search = e.target.value"
         placeholder="Search...">
        <font-awesome-icon
          v-if="search"
          id="clear_search"
          @click="search=''"
          :icon="['fa', 'times']" size="lg" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="col-6-sm button" @click="sort='az'" v-bind:class="{selected: sort=='az'}">
          A-Z
        </div>
        <div class="col-6-sm button" @click="sort='new'" v-bind:class="{selected: sort=='new'}">
          Newest
        </div>
      </div>
    </div>
    <div class="row">
      <transition-group enter-active-class="swing-in-top-fwd"
        leave-active-class="swing-out-bottom-bck" >
        <MaskElement
          v-for="maskElement in masks"
          :maskElement="maskElement"
          v-bind:key="maskElement.name"
        />
      </transition-group>
      <transition-group enter-active-class="swing-in-top-fwd"
        leave-active-class="swing-out-bottom-bck" >
        <MaskElement
          v-for="maskElement in soldOut"
          :maskElement="{...maskElement, soldOut: true}"
          v-bind:key="maskElement.name"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import MaskElement from './mask/Mask.vue'
import Mixin from './mixins/HelperFunctions.js'
export default {
  mixins: [Mixin],
  components: {
    MaskElement: MaskElement
  },
  name: 'HelloWorld',
  props: {
    msg: String
  },
  mounted() {},
  data: function (){
    return {
      search: '',
      sort: 'az',
      soldOut: []
    }
  },
  methods: {
  },
  computed: {
    masks () {
      let vm = this
      let initialFilter= this.$store.getters.getMasks.filter(mask=>{
        if(vm.search.length>0){
          let reg = vm.search.trim().split(' ').join('|')
          let result = mask.description.match(new RegExp( reg, 'ig'))
          let name = mask.name.match(new RegExp( reg, 'ig'))
          if ((result && result.length) || (name && name.length)){
            return result || name
          } else {
            return 0
          }
        } else {
          return 1
        }
      })
      let sorted = []
      switch (vm.sort) {
        case 'az':
          sorted = initialFilter.sort((a, b)=>{
            if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
          })
          break;
        case 'new':
          sorted = initialFilter.sort((a, b)=>{
            if(parseInt(a.id) < parseInt(b.id)) { return 1; }
            if(parseInt(a.id) > parseInt(b.id)) { return -1; }
            return 0;
          })
          break;
        default:

      }
      vm.soldOut = sorted.filter(mask => {
        return mask.available - (mask.pending | 0) <= 0
      })
      return sorted.filter(mask => {
        return mask.available - (mask.pending | 0) > 0
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.search {
  padding-left: 20px;
  width: calc(100% - 20px);
  border-radius: 5px;
  height: 20px;
}
#clear_search {
  top: -35px;
  padding-right: 3%;
  position: relative;
  float: right;
  color: $oroGray;
  &:hover {
    cursor: pointer;
    color: rgba($oroGray, .8);
  }
}
.selected {
  font-weight: bold;
  &:after{
    content: " ";
    border-bottom: 2px solid $oroGold;
    border-radius: 5px;
    display: flex;
    margin: 0 auto;
    width: 50%;
  }
}
</style>
